import React, {memo} from "react"

export const BadRequest = memo(() => {
    return (
        <div className="container" style={{flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center'}}>
            <p style={{fontSize: 60, fontWeight: 'bold', marginBottom: 0}}>404</p>
            <p style={{fontSize: 40, marginTop: 0}}>Страница не найдена.</p>

        </div>
    )
})
